// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  lang: 'en',
  baseUrl: 'https://staging-ikf.kelolain.id/ikf-api/public',
  baseUrlShare: 'https://staging-ikf.kelolain.id/',
  API2Url: 'https://staging-ikf.kelolain.id/api',
  API3Url: 'https://beta.unictdev.com/unictive-location/api',
  xendit: {
    apiKey: 'xnd_public_production_OPAYvRG7s8sDuBwR11XGDGuqpdR2E5YtfLuh2pMxDp2wslZERmSSv7AdyaNJt',
    apiKeyDev: 'xnd_public_development_9aeVRqV1KRNEhIq2vOishO3tSM1e36oJFybIpVjQDmfpLGwCUCQfiDwMamxu'
  },
  firebase : {
    apiKey: "AIzaSyCGYekspA7aFTKWSC571B4LD3-jZGYpP6o",
    authDomain: "kelolain-275609.firebaseapp.com",
    databaseURL: "https://kelolain-275609.firebaseio.com",
    projectId: "kelolain-275609",
    storageBucket: "kelolain-275609.appspot.com",
    messagingSenderId: "1090328511833",
    appId: "1:1090328511833:web:fbdd941e3c729d3d3d3848",
    measurementId: "G-JNCK6KT81P"
  },
  zoom : {
    apiKey: "jj_mev97TVSjc98mY7Qohg",
    apiSecret: "JwZmABmAlslp9twCtM4MoRE6HJGUWNDPeiGa"
  },
  baseUrl_location: 'https://beta.unictdev.com/unictive-location/api/get_data',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
